import styled from 'styled-components';

export default styled.div`
  background-color: var(--grey800);
  color: #fff;
  height: 24px;
  display: flex;
  align-items: center;
  overflow: hidden;
  max-width: 100%;

  .booking-region {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 100%;
    line-height: 24px;
    background: var(--grey900);
    margin-right: 0;
  }
`;
